import { Link } from 'react-router-dom';

export function BrandMark() {
  return (
    <Link className="brand-mark" to="/" aria-label="Sanjeom home">
      <span className="brand-mark__symbol" aria-hidden="true">
        <span className="brand-mark__moon" />
        <span className="brand-mark__star" />
      </span>
      <span>Sanjeom</span>
    </Link>
  );
}
